import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {findIn, addClass, findAll, findAllIn, closest, on} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tabs from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tabs(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    if (element.getAttribute('data-content-url')) {
        new Popover(element, {
            trigger: 'focus',
            container: closest('.modal', element) ? closest('.modal', element) : 'body',
            html: true,
            content: '<div class="js-dynamic-modal__content"><div class="loading-overlay loading-overlay--content loading-overlay--content-sm js-dynamic-modal__loading" hidden><div><div class="loading-spinner"><div class="loading-spinner__item loading-spinner__item--1"></div><div class="loading-spinner__item loading-spinner__item--2"></div><div class="loading-spinner__item loading-spinner__item--3"></div></div></div></div></div>',
            template: '<div class="popover js-dynamic-popover" role="tooltip">' +
                '<div class="popover-arrow"></div>' +
                '<h3 class="popover-header"></h3>' +
                '<div class="popover-body">' +
                '</div></div>'
        });
    } else {
        new Popover(element, {
            html: true,
            trigger: 'focus'
        });
    }
});

import * as lightbox from '@elements/lightbox';
lightbox.init({
    mobileSettings: {
        controls: true,
        showCloseIcon: true
    }
});

import * as rangeSlider from '@elements/range-slider';
onFind('.js-range-slider', function (slider) {
    rangeSlider.createRangeSlider(slider, {
        onSet: (sliderObj) => {
            addClass('is-selected', slider);

            findIn('.js-range-slider__val-display', slider).value = sliderObj.values[0] + ' - ' + sliderObj.values[1];

            if (slider.getAttribute('data-input-group')) {
                findAll('input[name="'+ slider.getAttribute('data-input-group') +'"]').map((input) => input.checked = false)
            }
        }
    }, {
        slider: '.js-range-slider__slider',
        inputMin: '.js-range-slider__min',
        inputMax: '.js-range-slider__max'
    });

    findAllIn('.js-range-slider__input', slider).map((input) => {
        on('change', () => {
            findIn('.js-range-slider__slider', slider).noUiSlider.set([findIn('.js-range-slider__min', slider).value, findIn('.js-range-slider__max', slider).value])
        }, input);
    });

    if (closest('.js-product-grid__submit-section', slider)) {
        on('keydown', function (evt) {
            if (evt.keyCode === 13) {
                findIn('.js-range-slider__slider', slider).noUiSlider.set([findIn('.js-range-slider__min', slider).value, findIn('.js-range-slider__max', slider).value])
            }
        }, closest('.js-product-grid__submit-section', slider));
    }
});

import * as productNumberSpinner from './scripts/product-number-spinner'
productNumberSpinner.init();

import * as productGrid from './libs/product-grid/index';
app.productGrid = productGrid.init();

import * as productGridQuickFilter from './libs/product-grid/quick-filter';
productGridQuickFilter.init();

import * as products from './scripts/product-item'
products.init();

import * as overlay from './scripts/overlay'
overlay.init();

import * as dynamicModal from './scripts/dynamic-modal'
dynamicModal.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as video from './scripts/video';
video.init();

import * as localizedVideo from './scripts/localized-video';
localizedVideo.init();

import * as dropdownSubmenu from './scripts/dropdown-submenu';
dropdownSubmenu.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as anchorNav from '@elements/anchor-nav/bootstrap-5';
anchorNav.init({
        renderItem: function (text, anchor) {
            return '<li class="nav-item anchor-nav__item flex-shrink-0"><a class="nav-link js-smoothscroll__link anchor-nav__link" href="#' + anchor + '"><span class="icon icon-chevron anchor-nav__link-icon"></span>'+ text + '</span></a></li>';
        },
        smoothScroll: false,
        scrollSpy: true,
        scrollSpyTarget: '.js-anchor-nav',
        scrollSpyOffset: matchMedia('(max-width: 767px)').matches ? 152 : 200
    },
    {
        list: '.js-anchor-nav__list',
        item: '.js-anchor-nav__item'
    }
);

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({scrollOffset: matchMedia('(max-width: 767px)').matches ? 152 : 190, initialPosition: true});

import * as anchorNavSticky from './scripts/anchor-nav-sticky';
anchorNavSticky.init();

import * as googleMap from './scripts/google-map';
googleMap.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as brandSlider from './scripts/brand-slider';
if(_config.brandSlider === true){
    brandSlider.init();
}

import * as collapseAll from './scripts/collapse-all';
collapseAll.init();

import * as filterBoxCollapse from './scripts/filter-box-collapse'
filterBoxCollapse.init();